<div class="error" *ngIf="!success && showError">
    <div class="icon">
        <bc-icon name="circle-error" class="error-icon"></bc-icon>
    </div>
    <p><b>!Hubo un problema!</b></p>
</div>

<div *ngIf="!showError">
    <app-menu 
        showMenu="true"
        [showBackButton]="!success"
        (buttonBack)="buttonBack()"
    ></app-menu>

    <div class="successSign" *ngIf="success" id="success-sign">
        <bc-icon name="circle-check-filled" class="info-icon"></bc-icon>
        <p><b>¡Firma electrónica exitosa!</b></p>
    </div>

    <div class="insuranceType" [style.--top-image]="this.topImage">
        <div class="insuranceText">
            <p class="title" *ngIf="success">Expedido exitosamente:</p>
            <p><b>{{ policy.insurance }}</b></p>
            <p class="price">por <b>${{ policy.month_value | thousandsPipe }}</b> mensuales</p>
        </div>
        <div class="insuranceImg">
            <img loading="lazy" bc-img-fluid src="../../../../assets/img/SmileWoman.png" alt="">
        </div>
    </div>

    <div class="insuranceInfo">
        <div class="insuranceInfoSuccess" *ngIf="success">
            <p class="date">Fecha de firma exitosa: {{ dateSign | date:'d MMM y - h:mm a' }}</p>
            <p class="note"><b>Ten en cuenta:</b></p>
            <div class="info">
                <bc-icon name="mail" class="info-icon"></bc-icon>
                <p>Enviamos una copia del seguro que acabas de firmar al correo electrónico <b>{{userMail | censureEmailPipe}}</b></p>
            </div>
        </div>
        <div class="insuranceInfoFail" *ngIf="!success">
            <div class="icon">
                <bc-icon name="hand-five" class="info-icon"></bc-icon>
            </div>
            <div>
                <p><b>No es posible continuar con la firma</b></p>
                <br>
                <p>Si estás en una sucursal pídele a tu asesor que <b>imprima la póliza</b> para firmarla o intenta nuevamente en dos horas para realizar la firma electrónica. </p>
                <!-- <br>
                <p>En caso de que desees cancelar el seguro, díselo al asesor para empezar este proceso.</p> -->
            </div>
        </div>
    </div>

    <div class="finish-button">
        <button bc-button sizeButton="small" [id]="'btn-finish'" (click)="signOtherPolicy()" *ngIf="success">
            <p *ngIf="success">Firma otro seguro</p>
        </button>
        <button bc-button sizeButton="small" [id]="'btn-finish'" (click)="retry()" *ngIf="!success && !auth">
            <p *ngIf="!success"> <bc-icon name="refresh" class="info-icon"></bc-icon> Intentar de nuevo</p>
        </button>
        <br>
        <a [href]="exitRedirect" class="exit">
            <button *ngIf="!success" bc-button [typeButton]="!auth?'secondary':'primary'" sizeButton="small" [id]="'btn-finish'">
                <p> {{ exitMessage }}</p>
            </button>
        </a>
    </div>
    <div class="footer">
        <app-footer></app-footer>
    </div>
</div>
